export default __webpack_public_path__ + "static/media/grey-thinnest.57e889ce.webp";